import { RequestAccessHandoffPayload } from './MyAccessRequests.types';

const REQUEST_ACCESS_HANDOFF_KEY = 'eua.requestAccess.handoff.v1';

export const saveRequestAccessHandoff = (payload: RequestAccessHandoffPayload): void => {
  sessionStorage.setItem(REQUEST_ACCESS_HANDOFF_KEY, JSON.stringify(payload));
};

export const consumeRequestAccessHandoff = (): RequestAccessHandoffPayload | null => {
  const rawValue = sessionStorage.getItem(REQUEST_ACCESS_HANDOFF_KEY);
  if (!rawValue) {
    return null;
  }

  sessionStorage.removeItem(REQUEST_ACCESS_HANDOFF_KEY);

  try {
    const parsed = JSON.parse(rawValue) as RequestAccessHandoffPayload;
    if (parsed?.version === 1 && parsed?.tenantName && parsed?.action && parsed?.item) {
      return parsed;
    }

    return null;
  } catch {
    return null;
  }
};
